// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Vars */
:root {
  --color-primary: #19346F;
  --color-primary-light: #8398c5;
  --color-secondary: #8C1A29;
}

/* Global */
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

html, body, #root {
  height: 100%;
}

p, h1, h2, h3, h4 {
  margin: .2rem 0;
}

h1 {
  font-size: 34px;
  line-height: 42px;
}

h3 {
  font-size: 17px;
}

p {
  font-size: 16px;
}

.ant-select-dropdown .ant-select-item {
  font-size: 16px !important;
}

/* Reset maps view */
.maplibregl-control-container {
  display: none;
}

/* ant-select */
.selectCustom {
  width: 96px !important;
  height: 28px !important;
}

.selectCustom .ant-select-selector {
  background: var(--color-primary) !important;
  border: none !important;
  border-radius: 16px !important;
  color: #fff !important;
}

.selectCustom.ant-select-open .ant-select-selection-item {
  color: var(--color-primary-light) !important;
}

.selectCustom .ant-select-arrow {
  color: #fff !important;
  transform: scale(0.8);
}

/* ant-button */
.ant-btn span {
  font-size: .85rem !important;
  font-weight: 500 !important;
}

/* ant-segmented */
.ant-segmented-group {
  border: 1px solid #CCC !important;
  background: #fff !important;
  border-radius: 7px;
}

.ant-segmented-thumb {
  background: var(--color-secondary) !important;
}

.ant-segmented-item {
  font-weight: 500;
  color: #000;
}

.ant-segmented-item.ant-segmented-item-selected {
  background: var(--color-secondary) !important;
  color: #fff !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,SAAS;AACT;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,aAAa;AACf;;AAEA,eAAe;AACf;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;EAC3C,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,6CAA6C;EAC7C,sBAAsB;AACxB","sourcesContent":["/* Vars */\n:root {\n  --color-primary: #19346F;\n  --color-primary-light: #8398c5;\n  --color-secondary: #8C1A29;\n}\n\n/* Global */\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\nhtml, body, #root {\n  height: 100%;\n}\n\np, h1, h2, h3, h4 {\n  margin: .2rem 0;\n}\n\nh1 {\n  font-size: 34px;\n  line-height: 42px;\n}\n\nh3 {\n  font-size: 17px;\n}\n\np {\n  font-size: 16px;\n}\n\n.ant-select-dropdown .ant-select-item {\n  font-size: 16px !important;\n}\n\n/* Reset maps view */\n.maplibregl-control-container {\n  display: none;\n}\n\n/* ant-select */\n.selectCustom {\n  width: 96px !important;\n  height: 28px !important;\n}\n\n.selectCustom .ant-select-selector {\n  background: var(--color-primary) !important;\n  border: none !important;\n  border-radius: 16px !important;\n  color: #fff !important;\n}\n\n.selectCustom.ant-select-open .ant-select-selection-item {\n  color: var(--color-primary-light) !important;\n}\n\n.selectCustom .ant-select-arrow {\n  color: #fff !important;\n  transform: scale(0.8);\n}\n\n/* ant-button */\n.ant-btn span {\n  font-size: .85rem !important;\n  font-weight: 500 !important;\n}\n\n/* ant-segmented */\n.ant-segmented-group {\n  border: 1px solid #CCC !important;\n  background: #fff !important;\n  border-radius: 7px;\n}\n\n.ant-segmented-thumb {\n  background: var(--color-secondary) !important;\n}\n\n.ant-segmented-item {\n  font-weight: 500;\n  color: #000;\n}\n\n.ant-segmented-item.ant-segmented-item-selected {\n  background: var(--color-secondary) !important;\n  color: #fff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
